/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Typography configuration for challenge pages. Supports custom font families.
 * @export
 * @interface ChallengeTypography
 */
export interface ChallengeTypography {
    /**
     * Font family for headings (e.g., "Hitmarker Condensed")
     * @type {string}
     * @memberof ChallengeTypography
     */
    headingFont?: string;
    /**
     * Font family for body text (e.g., "Inter")
     * @type {string}
     * @memberof ChallengeTypography
     */
    bodyFont?: string;
    /**
     * Font family for accent text like entries (e.g., "Hitmarker Text")
     * @type {string}
     * @memberof ChallengeTypography
     */
    accentFont?: string;
    /**
     * Font family for large display text (e.g., "Owners Narrow")
     * @type {string}
     * @memberof ChallengeTypography
     */
    displayFont?: string;
}

/**
 * Check if a given object implements the ChallengeTypography interface.
 */
export function instanceOfChallengeTypography(value: object): value is ChallengeTypography {
    return true;
}

export function ChallengeTypographyFromJSON(json: any): ChallengeTypography {
    return ChallengeTypographyFromJSONTyped(json, false);
}

export function ChallengeTypographyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeTypography {
    if (json == null) {
        return json;
    }
    return {
        
        'headingFont': json['headingFont'] == null ? undefined : json['headingFont'],
        'bodyFont': json['bodyFont'] == null ? undefined : json['bodyFont'],
        'accentFont': json['accentFont'] == null ? undefined : json['accentFont'],
        'displayFont': json['displayFont'] == null ? undefined : json['displayFont'],
    };
}

export function ChallengeTypographyToJSON(json: any): ChallengeTypography {
    return ChallengeTypographyToJSONTyped(json, false);
}

export function ChallengeTypographyToJSONTyped(value?: ChallengeTypography | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'headingFont': value['headingFont'],
        'bodyFont': value['bodyFont'],
        'accentFont': value['accentFont'],
        'displayFont': value['displayFont'],
    };
}

